/**
 * API地址配置文件
 * 吴程飞
 * 2019-03-12 08:23:03
 */
//中心重要服务
export const CenterImportant = 'https://jcenter.yipuda.cn/center-important-business';
//中心一般服务
export const CenterGeneral = 'https://jcenter.yipuda.cn/center-general-business';
//小程序服务
export const RunlegMiniApp = 'https://jmember.yipuda.cn/runleg-business';//http:yunwei.yipuda.cn/home.php/home/defaulthome
//商家一般服务
export const MarketGeneral = 'https://jrider.yipuda.cn/marketnormalbusiness';
//商家重要服务
export const MarketImportant = 'https://jrider.yipuda.cn/marketimportantbusiness';
//用户重要服务
export const MemeberImportant = "https://jrider.yipuda.cn/member-important";
//用户一般服务
export const MemeberGeneral = "https://jrider.yipuda.cn/member-general";
//骑手orderhistory
export const RiderOrderhistory = "https://jrider.yipuda.cn/orderhistorynew";
//骑手orderprocess
export const RiderOrderprocess = "https://jrider.yipuda.cn/orderprocessnew";

export const BackMerchantManagementImportant = "https://jrider.yipuda.cn/backstageimportant";



// WEBPACK FOOTER //
// ./src/BasePredApiConfig.js